import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import { authFetch } from "../context/AuthContext";

export default function BigThreeReading() {
    const [reading, setReading] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        authFetch("get", "/profile/big-three-reading")
            .then((r) => setReading(r.data))
            .finally(() => setLoading(false));
    }, []);

    return (
        <>
            <Navbar />
            <main className="min-h-screen pt-28 pb-12 px-6">
                <div className="max-w-3xl mx-auto">
                    <p className="label-tracking text-gold">Your Soul Signature</p>
                    <h1 className="font-serif text-5xl mt-2">Big Three Reading</h1>

                    {reading && (
                        <p className="text-muted mt-3 font-serif italic text-lg">
                            ☉ {reading.sun} &nbsp;·&nbsp; ☽ {reading.moon} &nbsp;·&nbsp; ↑ {reading.rising}
                        </p>
                    )}

                    <div className="glass-gold ai-card p-8 mt-6" data-testid="big-three-reading-card">
                        {loading ? (
                            <p className="text-muted italic">Composing your celestial signature...</p>
                        ) : (
                            <p className="font-serif text-lg leading-relaxed whitespace-pre-wrap" data-testid="big-three-text">
                                {reading?.reading}
                            </p>
                        )}
                    </div>
                </div>
            </main>
        </>
    );
}
